import { Box, Typography } from '@mui/material';

export const CopilotDisclaimer = () => (
  <Box sx={{ px: 0.5, pt: 1.5 }}>
    <Typography variant="caption" color="text.secondary">
      G.AI can make mistakes. Review responses before using them. Official emissions calculations are performed by the platform’s calculation engine.
    </Typography>
  </Box>
);
